import { useCallback, useState } from "react";

const useSessionStorage = (key: string) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>("");

  const saveDataAtSessionStorage = useCallback(
   ({ data: newData }: any) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(newData));
        setLoading(false);
      } catch (err: any) {
        setError(err);
      }
    },
    [key, setLoading, setError]
  );

  const getSessionStorageData = useCallback( () => {
    try {
      const element: any = sessionStorage.getItem(key);
      setData(JSON.parse(element));
      setLoading(false);
    } catch (err: any) {
      setError(err);
    }
  }, [key, setLoading, setError]);

  const removeSessionStorageData = useCallback(() => {
    try {
      sessionStorage.removeItem(key);
      setData(null);
      setLoading(false);
    } catch (err: any) {
      setError(err);
    }
  }, [key, setLoading, setError]);

  return {
    getSessionStorageData,
    saveDataAtSessionStorage,
    removeSessionStorageData,
    data,
    loading,
    error
  };
};

export default useSessionStorage;
